import "./Login.css";
import React from "react";
import { images } from "../../../Assets/assetsHelper";
import LoginForm from "../../../Components/Organisms/Forms/LoginForm/LoginForm";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Box, Link, Typography } from "@mui/material";
import config from "../../../config";

function Login({ accountCode }) {
  return (
    <div className="LoginPage">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          margin: { xs: "0px", md: "10px 20px" },
          alignItems: "center",
        }}
      >
        <img src={config.APP_LOGO} alt="Logo" className="LoginLogo" />
        <Breadcrumbs className="LoginBreadcrumbs">
          <Typography sx={{}}>AI Challenge 2025</Typography>
          <Typography sx={{ color: "text.primary" }}>Sign In</Typography>
        </Breadcrumbs>
      </Box>
      <div className="signInContainer">
        <LoginForm accountCode={accountCode} />
      </div>
      <div className="signInDataContainer">
        <Typography
          sx={{
            color: "primary.main",
            fontSize: { xs: "26px", md: "35px" },
            fontWeight: "500",
          }}
        >
          Welcome!
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "14px", md: "16px" },
          }}
        >
          This platform is your centralized hub for managing project submissions
          for the AI Challenge Competition. Designed specifically for
          participating teams, it ensures a smooth, organized, and secure
          process to upload, track, and evaluate competition entries.
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "16px", md: "20px" },
            fontWeight: "600",
            marginTop: "10px",
          }}
        >
          What You Can Do Here:
        </Typography>
        <ul style={{ marginLeft: "30px" }}>
          <li>Submit your team’s project or code for evaluation.</li>
          <li>View submission deadlines, status updates, and feedback.</li>
          <li>Edit or replace your submission before the deadline.</li>
        </ul>
        <Typography
          sx={{
            fontSize: { xs: "16px", md: "20px" },
            fontWeight: "600",
            marginTop: "10px",
          }}
        >
          Need Assistance?
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "14px", md: "16px" },
          }}
        >
          If you encounter any issues with submitting your project or need
          technical support, please reach out to:{" "}
          <a
            href="mailto:support@the-aichallenge.org"
            style={{ textDecoration: "underline" }}
          >
            support@the-aichallenge.org
          </a>
          .
        </Typography>
      </div>
    </div>
  );
}

export default Login;
